import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { setActiveCurrency } from "@/lib/utils";

export function CurrencyProvider({ children }: { children: React.ReactNode }) {
  const { data } = useQuery<{ baseCurrency: string }>({
    queryKey: ["/api/currency-settings"],
    queryFn: async () => {
      const res = await fetch("/api/currency-settings");
      if (!res.ok) return { baseCurrency: "USD" };
      return res.json();
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  useEffect(() => {
    if (data?.baseCurrency) {
      setActiveCurrency(data.baseCurrency);
    }
  }, [data?.baseCurrency]);

  return <>{children}</>;
}
